import { Properties } from './StackTrackerService';

export type ReportError = (error: unknown, properties?: Properties) => void;

const isObject = (value: unknown): value is object => typeof value === 'object' && value !== null;

// A fatal component error reaches `vue:error`, then `app:error` through `showError()`, which
// passes the same error or a wrapper whose `cause` is the original.
export const createErrorReporter = (capture: ReportError, isIgnored: (error: unknown) => boolean): ReportError => {
    const reported = new WeakSet<object>();

    return (error, properties) => {
        if (isIgnored(error)) return;

        if (isObject(error)) {
            const cause = (error as { cause?: unknown }).cause;
            if (reported.has(error) || (isObject(cause) && reported.has(cause))) return;

            reported.add(error);
            if (isObject(cause)) reported.add(cause);
        }

        capture(error, properties);
    };
};
